import { addDays, differenceInCalendarDays, startOfDay } from "date-fns";

/** จำนวนวันก่อนครบกำหนดที่ถือว่า "ใกล้เกินกำหนด" (= เริ่มช่วง 7 วัน) */
export const DOCUMENT_DUE_WARNING_DAYS = 7;

/** กำหนดชำระสูงสุดหลังออกเอกสาร (ช่วงนโยบาย 7–14 วัน) */
export const DOCUMENT_PAYMENT_DUE_DAYS = 14;

/** @deprecated ใช้ DOCUMENT_PAYMENT_DUE_DAYS */
export const QUOTATION_DEFAULT_VALIDITY_DAYS = DOCUMENT_PAYMENT_DUE_DAYS;

export type DocumentDueUrgency = "ok" | "warning" | "overdue";

export function resolveDocumentDueAt(input: {
  documentType: "quotation" | "invoice" | "receipt";
  status: string;
  issuedAt: Date | string | null;
  validUntil: Date | string | null;
  remainingAmount?: number;
  nextInstallmentDueAt?: Date | string | null;
}): Date | null {
  if (input.status === "voided" || input.status === "draft") return null;

  if (input.documentType === "quotation") {
    if (input.status !== "issued" && input.status !== "approved") return null;
    // ใบสะเสนอราคา: แจ้งเตือนเฉพาะเมื่อกำหนดวันหมดอายุชัดเจน (ไม่ใช่กำหนดชำระ 7–14 วัน)
    if (input.validUntil) return new Date(input.validUntil);
    return null;
  }

  if (input.documentType === "invoice") {
    if (input.status !== "issued" && input.status !== "partial") return null;
    if ((input.remainingAmount ?? 0) <= 0) return null;
    if (input.nextInstallmentDueAt) {
      return new Date(input.nextInstallmentDueAt);
    }
    if (input.issuedAt) {
      return addDays(new Date(input.issuedAt), DOCUMENT_PAYMENT_DUE_DAYS);
    }
    return null;
  }

  return null;
}

export function getDocumentDueUrgency(
  dueAt: Date | null,
  now: Date = new Date(),
  warningDays: number = DOCUMENT_DUE_WARNING_DAYS,
): DocumentDueUrgency | null {
  if (!dueAt) return null;

  const dueDay = startOfDay(dueAt);
  const today = startOfDay(now);
  const daysLeft = differenceInCalendarDays(dueDay, today);

  if (daysLeft < 0) return "overdue";
  if (daysLeft <= warningDays) return "warning";
  return "ok";
}

export function countDocumentAttention(
  items: Array<{ dueUrgency: DocumentDueUrgency | null | undefined }>,
) {
  return items.reduce(
    (acc, item) => {
      if (item.dueUrgency === "overdue") acc.overdue += 1;
      if (item.dueUrgency === "warning") acc.warning += 1;
      if (item.dueUrgency === "warning" || item.dueUrgency === "overdue") {
        acc.total += 1;
      }
      return acc;
    },
    { warning: 0, overdue: 0, total: 0 },
  );
}
